import axios from "axios";

export const deleteCompanyById = async (id) => {
  try {
    const response = await axios.delete(`http://localhost:8080/webnet-hms/api/company/${id}`);
    window.alert("Company deleted successfully!");
    return response.data;
  } catch (error) {
    console.error("Error deleting Company:", error);
    window.alert("Failed to delete Company.");
  }
};
